import { useMemo } from 'react';
import { formatCellsToolbarItem } from './FormatCellsDialog';
import type { SheetToolbarItem, SheetToolbarItems } from './useSheetToolbarItems.types';

export interface UseSheetToolbarItemsArgs {
    fitColumnsToolbarItem: SheetToolbarItem;
    onOpenFormatCells: () => void;
    /** Size-capped workbook: only the (non-mutating) fit-columns item is offered. */
    readOnly?: boolean;
}

/**
 * Assembles the <Workbook customToolbarItems> list — kept out of
 * useSheetEditorDialogs, which otherwise has nothing to do with toolbar
 * assembly beyond opening the Format Cells dialog.
 */
export const useSheetToolbarItems = ({
    fitColumnsToolbarItem,
    onOpenFormatCells,
    readOnly = false,
}: UseSheetToolbarItemsArgs): SheetToolbarItems => {
    const formatCellsItem = useMemo(() => formatCellsToolbarItem(onOpenFormatCells), [onOpenFormatCells]);
    return useMemo(
        () => (readOnly ? [fitColumnsToolbarItem] : [fitColumnsToolbarItem, formatCellsItem]),
        [readOnly, fitColumnsToolbarItem, formatCellsItem],
    );
};
